<template>
  <div class="col-lg-12">
    <div class="row d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <span class="ml-2 label-bold color-dark-purple">FORMAÇÃO SUPERIOR (OBRIGATÓRIO)</span>
      </div>
      <div>
        <button
          type="button"
          class="f14 btn-add-items-tb bg-light-purple color-white"
          @click="openForm()"
        >
          ADICIONAR
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div
        class="d-flex justify-content-center align-item-center row mb-1 border-dark-purple pt-3 pb-4"
        v-if="educations.length === 0"
      >
        <h4 class="center f15 color-dark-purple">
          NENHUMA EXPERIÊNCIA EDUCACIONAL FOI INFORMADA AINDA.
        </h4>
      </div>
    </div>

    <div
      v-for="(education, index) in educations"
      :key="education.id"
    >
      <div class="mt-3">
        <div class="row mb-1 border-dark-purple pt-3 pb-4">
          <div class="col-lg-12">
            <div>
              <div class="d-flex justify-content-between">
                <div>
                  <span
                    class="label-bold color-dark-purple"
                  >{{ education.study_area }}</span>
                </div>
                <div
                  style="margin-right: 10px !important"
                  class="menu_column nav nav-tabs"
                >
                  <li
                    style="background-color: #f4f4f4 !important"
                    class="nav-item dropdown"
                  >
                    <div
                      class="nav-link"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style="background-color: #fcfcfc"
                    >
                      <font-awesome-icon icon="ellipsis-h" />
                    </div>
                    <div class="dropdown-menu drop-down-tb">
                      <div class="dropdown-item pointer">
                        <span
                          class="mt-0 mb-0"
                          @click="openForm(education.id)"
                        >
                          EDITAR
                        </span>
                        <i class="ml-4 fa fa-pencil-alt scale_1" />
                      </div>
                      <div class="dropdown-item pointer">
                        <span
                          class="mt-0 mb-0"
                          @click="deleteEducation(education.id, index)"
                        >
                          DELETAR
                        </span>
                        <i class="ml-3 fas fa-trash-alt scale_1" />
                      </div>
                    </div>
                  </li>
                </div>
              </div>
              <div>
                <span style="text-transform: capitalize">{{ education.institution }}
                  |
                  {{ education.city }}</span>
              </div>
              <div>
                <div>
                  <span
                    v-if="education.start_date"
                    style="text-transform: capitalize"
                  >
                    {{ education.start_date }} - {{ education.end_date }}
                  </span>
                  <span v-else>
                    Precisa atualizar data
                  </span>
                </div>
              </div>
              <div class="mt-3">
                <div>
                  <span>Descrição:</span>
                </div>
                <div>
                  <span style="text-transform: capitalize">{{
                    education.description
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EducationForm from "./Form.vue";
// import { format } from "date-fns";
import axios from "axios";

export default {
  props: ["candidate_id", "job"],
  mounted() {
    eventBus.$on("getEducations", () => {
      this.getEducations();
    });

    this.getEducations();
  },
  data: () => ({
    educations: [],
    formations: [
      "Colegial",
      "Curso Técnico",
      "Treinamento",
      "Graduação",
      "Iniciação Cientifica",
      "Pós-Graduação",
      "Mestrado",
      "Doutorado",
      "Phd",
      "Outros",
    ],
  }),
  methods: {
    getEducations() {
      this.educations = [];
      let url = "/candidates/educations";
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/educations`;
      }
      axios.get(url).then((response) => {
        for (let education of response.data.educations) {
          let city = "";
          if (education.city_other_country) {
            city = education.city_other_country;
          } else {
            city = education.city_name
              ? education.city_name + " / " + education.state_uf
              : "Precisa atualizar cidade";
          }
          this.educations.push({
            id: education.id,
            description: education.description,
            start_date: education.start_date
              ? this.formatHard(education.start_date)
              : "",
            end_date: education.end_date
              ? this.formatHard(education.end_date) : "",
            institution: education.institution_name,
            study_area: education.study_area_name,
            studying_here: education.studying_here,
            formation: this.formations[education.formation_type],
            city: city,
          });
        }
      });
    },
    formatHard(date){
      if(!date){
        return date;
      }
      
      let new_date = date.split(' ');
      new_date = new_date[0].split('-');
      return  new_date[1] + '/' + new_date[0]
    },
    openForm(id) {
      this.$modal.show(
        EducationForm,
        {
          education_id: id,
          candidate_id: this.candidate_id,
          job: this.job,
        },
        {
          width: "70%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    deleteEducation(id, index) {
      let conf = confirm("Tem certeza que deseja excluir este dado?");
      if (!conf) return;

      let url = `/candidates/educations/${id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/educations/${id}`;
      }

      axios.delete(url).then((response) => {
        if (response.data.status) {
          this.$toast.success("Formação acadêmica excluido com sucesso!");
          if (this.educations[index].studying_here)
            eventBus.$emit("updateInfo");
          this.educations.splice(index, 1);
          return;
        }

        this.$toast.error("Não foi possivel excluir esta formação acadêmica.");
      });
    },
  },
};
</script>